import $ from 'jquery';

// IMPORT COMPONENTS
import A11yUtils from '@core/base/scripts/utils/a11y-utils';


export default class {
  constructor(navbar) {
    this.CLASSES = {
      btnsSelector: '.subnav__backdrop,.subnav__back-btn',
      open: 'navigation-bar__link--open',
      move: 'subnav--move',
      show: 'subnav--show'
    };
    this.ANIM_TIME = 150;
    this.navbar = navbar;
    this.$subnav;
    this._isMobile;
    this._focusables;
    this.opened = false;
    this.$currentLink = null;
  }

  init() {
    $(this.CLASSES.btnsSelector).on('click', (e) => {
      e.preventDefault();
      this.navbar.closeSubnav();
    });
  }

  open(from, x, y, callback) {
    if (this.$lastSubnav) {
      this.close();
    }
    //
    this.$currentLink = from;
    const id = this.$currentLink.attr(A11yUtils.ARIA.controls);
    this.setId(id);
    //
    this.$currentLink.attr(A11yUtils.ARIA.expanded, true).addClass(this.CLASSES.open);
    this.opened = true;
    this.$subnav = $(`#${id}`);
    //
    this.$subnav.addClass(this.CLASSES.show);
    this.$subnav.addClass(this.CLASSES.move);
    this.setPosition(x, y);

    setTimeout(() => {
      this.focusables = this.$subnav.find(A11yUtils.FOCUSABLES_VISIBLE);
      if (this.focusables.length > 0) {
        this.focusables[0].focus();
      }
      this.$lastSubnav = this.$subnav;
      if (callback) {
        callback();
      }
    }, this.ANIM_TIME);
  }

  close(callback) {
    this.opened = false;
    //
    this.$currentLink.focus().attr(A11yUtils.ARIA.expanded, false).removeClass(this.CLASSES.open);
    if (this.$lastSubnav) {
      this.$lastSubnav.removeClass(this.CLASSES.move);
    }
    setTimeout(() => {
      if (this.$lastSubnav) {
        this.$lastSubnav.removeClass(this.CLASSES.show);
        this.$lastSubnav = null;
      }
      if (callback) {
        callback();
      }
    }, this.ANIM_TIME);
  }

  reset() {
    if (this.isOpen()) {
      this.$subnav.removeClass(this.CLASSES.show);
      this.$subnav.removeAttr('style');
    }
    this.focusables = null;
  }

  setPosition(left, top) {
    this.$subnav.css({
      top: top,
      left: left
    });
  }

  setWidth(w) {
    this.$subnav.css({
      width: w
    });
  }

  getHeight() {
    return this.$subnav.outerHeight();
  }

  getOffsetTop() {
    return this.$subnav.offset().top;
  }

  setId(id) {
    this.id = id;
  }

  getSubnav() {
    return this.$lastSubnav;
  }

  isOpen() {
    return this.opened;
  }

  set focusables(focusables) {
    this._focusables = focusables;
  }

  get focusables() {
    return this._focusables;
  }
}
